import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { IScanQROrderFeature } from './scan-qr-order.feature.state';
import { getFailures, getIsLoading, getOrderFromSite, getSiteId } from './scan-qr-order.selectors';
import { ClearStateAction, getChooseLocationAction, setOrderFromSiteAction, setSiteIDAction } from './scan-qr-order.actions';
import { map } from 'rxjs/operators';
@Injectable()
export class ScanQROrderFacade {
  public isLoading$ = this.store.select(getIsLoading);
  public failures$ = this.store.select(getFailures);
  public siteId$ = this.store.select(getSiteId);
  public isOrderFromSite$ = this.store.select(getOrderFromSite).pipe(
    map((orderFromSite) => {
      if (orderFromSite) {
        const data = orderFromSite.split('_');
        return data.length > 0 && (data[0] === '1' || data[0] === '2');
      }
      return false;
    })
  );
  public orderFromSiteValue$ = this.store.select(getOrderFromSite).pipe(
    map((orderFromSite) => {
      if (orderFromSite) {
        const data = orderFromSite.split('_');
        const check = data.length > 0 && (data[0] === '1' || data[0] === '2');
        return check ? data[0] : null;
      }
      return null;
    })
  );

  constructor(private store: Store<IScanQROrderFeature>) {}

  public getChooseLocation(siteId: string): void {
    this.store.dispatch(getChooseLocationAction({ siteId }));
  }

  public setSiteID(siteId: string): void {
    this.store.dispatch(setSiteIDAction({ siteId }));
  }

  public setOrderFromSite(orderFromSite: string): void {
    this.store.dispatch(setOrderFromSiteAction({ orderFromSite }));
  }

  public clearState(actionType?: string): void {
    this.store.dispatch(ClearStateAction({ actionType }));
  }
}
